<template>
    <div class="DeclarationItemBlcoks" v-if="DeclarationItem.length > 0">
        <div class="d-flex justify-content-between">
            <h2>ნივთები</h2>
            <p class="fullPrice">
                ჯამური ფასი:
                <span>
                    {{ priceCount(DeclarationItem) }}
                    {{
                        props.country === 2 || props.country === 4
                            ? "TL"
                            : props.currency.currency
                    }}
                </span>
            </p>
        </div>
        <div
            class="DeclarationItemBlcoksItem"
            v-for="(item, index) in DeclarationItem"
            :key="index"
        >
            <div class="avatar">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M12 21.6099V12.5399"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M17 13.24V9.58002L7.51001 4.09998"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </div>
            <div class="name">
                <p>
                    {{ item.title }}
                    {{
                        props.country === 2 || props.country === 4
                            ? "TL"
                            : props.currency.currency
                    }}
                </p>
                <span>{{ item.parcle_type.name }} </span>
            </div>
            <div class="spacer"></div>

            <button
                class="DeclarationItemDelete"
                :disabled="props.parcel.declaration && pageId == 3"
                @click="onDelete(index)"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <g id="trash" transform="translate(-108 -188)">
                        <path
                            id="Vector"
                            d="M18,.5C14.67.17,11.32,0,7.98,0A59.068,59.068,0,0,0,2.04.3L0,.5"
                            transform="translate(111 193.48)"
                            fill="none"
                            stroke="rgba(18,32,43,0.5)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M0,2.97.22,1.66C.38.71.5,0,2.19,0H4.81C6.5,0,6.63.75,6.78,1.67L7,2.97"
                            transform="translate(116.5 190)"
                            fill="none"
                            stroke="rgba(18,32,43,0.5)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-3"
                            data-name="Vector"
                            d="M13.7,0l-.65,10.07c-.11,1.57-.2,2.79-2.99,2.79H3.64C.85,12.86.76,11.64.65,10.07L0,0"
                            transform="translate(113.15 197.14)"
                            fill="none"
                            stroke="rgba(18,32,43,0.5)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-4"
                            data-name="Vector"
                            d="M0,0H3.33"
                            transform="translate(118.33 204.5)"
                            fill="none"
                            stroke="rgba(18,32,43,0.5)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-5"
                            data-name="Vector"
                            d="M0,0H5"
                            transform="translate(117.5 200.5)"
                            fill="none"
                            stroke="rgba(18,32,43,0.5)"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-6"
                            data-name="Vector"
                            d="M0,0H24V24H0Z"
                            transform="translate(108 188)"
                            fill="none"
                            opacity="0"
                        />
                    </g>
                </svg>
            </button>
        </div>
    </div>
</template>
<script>
import {
    defineComponent,
    onBeforeMount,
    onBeforeUnmount,
} from "@vue/composition-api";
import { useDeclaration } from "../../hooks/declaration";
import { useParcels } from "../../hooks/parcels";
export default defineComponent({
    props: {
        id: {
            type: Number,
            default: 0,
        },
        parcel: {
            type: Object,
            default: null,
        },
        country: {
            type: Number,
            default: null,
        },
        currency: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const { getDeclarationItems, onDelete, DeclarationItem } =
            useDeclaration();

        const { pageId } = useParcels();

        onBeforeMount(async () => {
            await getDeclarationItems(props.id);
        });
        onBeforeUnmount(() => {
            DeclarationItem.value = [];
        });
        const priceCount = (items) => {
            return items
                .map((e) => Number(e.title))
                .reduce((num, a) => {
                    return num + a;
                }, 0)
                .toFixed(2);
        };

        return {
            DeclarationItem,
            onDelete,
            pageId,
            props,
            priceCount,
        };
    },
});
</script>
